import { RootState } from 'editor/src/store/index';

const getAdvancedFlatPreviews = (state: RootState) => state.editorModules.preview.advancedFlatPreviews;

export default getAdvancedFlatPreviews;
